import React, { useEffect, useRef, useState } from "react";
import ReactMapboxGl, { Popup, Marker } from "react-mapbox-gl";
import getCenter from "geolib/es/getCenter";
// import BackArrow from "../../assets/images/back-arrow.png";
import CloseIcon from "../../assets/images/close.png";
import MapMarker from "../../assets/images/map-marker.png";
import classes from "./mapview.module.scss";
import { citiesMap } from "../../config/cityData";
import { groupBy } from "lodash";
import cs from "classnames";
import { useMedia } from "react-use";

const Map = ReactMapboxGl({
  accessToken:
    "pk.eyJ1IjoibGF2c2hhaCIsImEiOiJja3F1eTRoeDYwOTljMnBvNXBuYWxpanR0In0.VUKqSS8aNGA6EZxovM8hCg",
});

const alphabets = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

const MapView = ({ locations = [] /*  city, setCity, market */ }) => {
  // const [cityLocations, setCityLocations] = useState([]);
  const [selectedLocation, setSelctedLocation] = useState(null);
  const [grouppedData, setGrouppedData] = useState(null);
  const [center, setCenter] = useState([0, 0]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const mapRef = useRef(null);
  const isMobileView = useMedia("(max-width: 768px)");
  const listRef = useRef(null);

  // useEffect(() => {
  //   const filteredLocations = [
  //     ...locations.filter(
  //       (loc) => loc?.acf?.city === city && loc?.acf?.market === market
  //     ),
  //   ];
  //   setCityLocations([...filteredLocations]);
  //   const centerPoint = getCenter(
  //     filteredLocations.map((loc) => ({
  //       latitude: loc?.acf?.google_map_location.lat,
  //       longitude: loc?.acf?.google_map_location.lng,
  //     }))
  //   );
  //   setCenter([centerPoint.longitude || 0, centerPoint.latitude || 0]);
  //   setSelctedLocation(null);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [city, market]);

  useEffect(() => {
    if (selectedLocation) {
      const loc = selectedLocation?.acf?.google_map_location || null;
      const coords = loc ? [loc.lng, loc.lat] : [];

      if (isMobileView) {
        setTimeout(() => {
          mapRef.current.state.map.flyTo({
            center: coords,
            essential: true,
            zoom: 10,
            speed: 5,
          });
        }, 1000);
      } else {
        mapRef.current.state.map.flyTo({
          center: coords,
          essential: true,
          zoom: 10,
          speed: 5,
        });
      }
    } else {
      const centerPoint = getCenter(
        locations.map((loc) => ({
          latitude: loc?.acf?.google_map_location.lat,
          longitude: loc?.acf?.google_map_location.lng,
        }))
      );
      setGrouppedData({ ...groupBy(locations, "acf.city") });
      setCenter([centerPoint.longitude || 0, centerPoint.latitude || 0]);
      setSelctedLocation(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation]);

  const renderPopup = () => {
    const loc = selectedLocation?.acf?.google_map_location || null;
    const coords = loc ? [loc.lng, loc.lat] : [];
    return (
      <Popup coordinates={coords} offset={[0, -20]} style={{ padding: 0 }}>
        <div className={classes.popup}>
          <span
            className={classes.closeBtn}
            onClick={() => setSelctedLocation(null)}
          >
            <img src={CloseIcon} height={24} width={24} alt="Close" />
          </span>
          <h4>{selectedLocation?.title?.rendered}</h4>
          {selectedLocation.cuisine_type ? (
            <span>{selectedLocation.cuisine_type}</span>
          ) : null}
          {selectedLocation.acf?.address_field ? (
            <p>{selectedLocation.acf.address_field}</p>
          ) : null}
          <div
            className={classes.openBtn}
            onClick={() => {
              window.open(
                `https://www.google.com/maps/place/${selectedLocation?.acf?.address_field}/@${loc.lat},${loc.lng},10z`
              );
            }}
          >
            Show location
          </div>
        </div>
      </Popup>
    );
  };

  return (
    <div className={classes.root}>
      {!isMobileView ? (
        <h3 className="text-center" style={{ color: "#fd7e14" }}>
          Map
        </h3>
      ) : null}
      {isMobileView ? (
        <>
          <div className={cs(classes.LocationHeader, "text-white")}>
            <h2>Locations</h2>
          </div>
          <div className="w-100 px-5 my-4">
            <div className={cs(classes.ButtonContainer)}>
              <div
                className={cs(classes.button, {
                  [classes.activeButton]: isMenuOpen,
                })}
                onClick={() => setIsMenuOpen(true)}
              >
                LIST
              </div>
              <div
                className={cs(classes.button, {
                  [classes.activeButton]: !isMenuOpen,
                })}
                onClick={() => setIsMenuOpen(false)}
              >
                MAP
              </div>
            </div>
          </div>
        </>
      ) : null}

      <div className="position-relative w-100">
        <div className={classes.mapWrapper}>
          {!isMobileView ? (
            <div className={classes.alphaScroll}>
              {alphabets.map((letter) => (
                <span
                  onClick={() => {
                    const element = document.getElementById(`letter-${letter}`);
                    if (element) {
                      element.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest",
                      });
                    }
                  }}
                >
                  {letter}
                </span>
              ))}
            </div>
          ) : null}
          {!isMobileView || (isMobileView && isMenuOpen) ? (
            <div
              className={cs(classes.listContainer, {
                [classes.mobileListContainer]: isMobileView,
              })}
              ref={listRef}
            >
              <div className="pl-3">
                {grouppedData && Object.keys(grouppedData).length
                  ? Object.keys(grouppedData)
                      .sort((a, b) =>
                        a.toLowerCase() === b.toLowerCase()
                          ? 0
                          : a.toLowerCase() < b.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((city) => (
                        <div
                          id={`letter-${city[0].toUpperCase()}`}
                          className="d-flex flex-column"
                          key={city}
                        >
                          <div className={classes.header}>
                            <h2 className="mb-0">{citiesMap[city] || city}</h2>
                          </div>
                          <div className={classes.list}>
                            {grouppedData[city]
                              .sort((a, b) =>
                                a?.title?.rendered?.toLowerCase() ===
                                b?.title?.rendered?.toLowerCase()
                                  ? 0
                                  : a?.title?.rendered?.toLowerCase() <
                                    b?.title?.rendered?.toLowerCase()
                                  ? -1
                                  : 1
                              )
                              .map((location) => {
                                // const loc =
                                //   location?.acf?.google_map_location || null;
                                // const coords = loc ? [loc.lng, loc.lat] : [];
                                return (
                                  <div
                                    key={location.id}
                                    className={classes.listItem}
                                    onClick={() => {
                                      setSelctedLocation(location);
                                      setIsMenuOpen(false);
                                      // if (true) {
                                      //   setTimeout(() => {
                                      //     mapRef.current.state.map.flyTo({
                                      //       center: coords,
                                      //       essential: true,
                                      //       zoom: 10,
                                      //       speed: 5,
                                      //     });
                                      //   }, 1000);
                                      // } else {
                                      //   mapRef.current.state.map.flyTo({
                                      //     center: coords,
                                      //     essential: true,
                                      //     zoom: 10,
                                      //     speed: 5,
                                      //   });
                                      // }
                                    }}
                                    anchor="bottom"
                                  >
                                    <h4 className={classes.itemTitle}>
                                      {location?.title?.rendered}
                                    </h4>
                                    {location.cuisine_type ? (
                                      <span className={classes.itemSubtitle}>
                                        {location.cuisine_type}
                                      </span>
                                    ) : null}
                                    {location.acf?.address_field ? (
                                      <p className={classes.address}>
                                        {location.acf.address_field}
                                      </p>
                                    ) : null}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      ))
                  : null}
              </div>
              {/* <div className={classes.header}>
                <img onClick={() => setCity(null)} src={BackArrow} alt="" />
                <h2 className="mb-0">{citiesMap[city]}</h2>
              </div> */}
              {/* <div className={classes.list}>
                {locations.map((location) => {
                  const loc = location?.acf?.google_map_location || null;
                  const coords = loc ? [loc.lng, loc.lat] : [];
                  return (
                    <div
                      key={location.id}
                      className={classes.listItem}
                      onClick={() => {
                        setSelctedLocation(location);
                        setIsMenuOpen(false);
                        if (isMobileView) {
                          setTimeout(() => {
                            mapRef.current.state.map.flyTo({
                              center: coords,
                              essential: true,
                            });
                          }, 1000);
                        } else {
                          mapRef.current.state.map.flyTo({
                            center: coords,
                            essential: true,
                          });
                        }
                      }}
                      anchor="bottom"
                    >
                      <h4 className={classes.itemTitle}>
                        {location?.title?.rendered}
                      </h4>
                      {location.cuisine_type ? (
                        <span className={classes.itemSubtitle}>
                          {location.cuisine_type}
                        </span>
                      ) : null}
                      {location.acf?.address_field ? (
                        <p className={classes.address}>
                          {location.acf.address_field}
                        </p>
                      ) : null}
                    </div>
                  );
                })}
              </div> */}
            </div>
          ) : null}
          {!isMobileView || (isMobileView && !isMenuOpen) ? (
            <Map
              // eslint-disable-next-line react/style-prop-object
              style="mapbox://styles/mapbox/dark-v10"
              containerStyle={{
                ...(isMobileView
                  ? {
                      height: "87vh",
                      width: "calc(100% - 0px)",
                    }
                  : {
                      height: "80vh",
                      width: "calc(100% - 300px)",
                    }),
              }}
              ref={mapRef}
              animationOptions={{
                offset: center,
              }}
              flyToOptions={{
                speed: 8,
              }}
              zoom={!selectedLocation ? [3.5] : [10]}
              center={center}
            >
              {locations.map((location) => {
                const loc = location?.acf?.google_map_location || null;
                const coords = loc ? [loc.lng, loc.lat] : [];

                return (
                  <Marker
                    id={`marker-${location.id}`}
                    key={location.id}
                    coordinates={coords}
                    anchor="bottom"
                    onClick={() => setSelctedLocation(location)}
                  >
                    <img src={MapMarker} height={18} width={18} alt="Marker" />
                  </Marker>
                );
              })}
              {selectedLocation ? renderPopup() : null}
            </Map>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MapView;
